<h2 mat-dialog-title *ngIf="isNew">New Evidence</h2>
<h2 mat-dialog-title *ngIf="!isNew">Edit Evidence</h2>
<mat-dialog-content>



<iaud-evidence-edit-form [evidence]="evidence" (fileChanged)="fileChanged($event)" (isValidChange)="toggleFormValidity($event)"
  (formData)="setFormData($event)"></iaud-evidence-edit-form>







</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button mat-dialog-close>Cancel</button>
  <button mat-raised-button [disabled]="!isFormValid" [color]="'accent'" (click)="update()">Update
  </button>
</mat-dialog-actions>